import React, {Component} from 'react';
import classNames from 'classnames';
import {Grid} from 'material-ui';
import Elements from './Elements'
import Sticky from 'react-sticky-el';

class ElementsContainer extends Component {

    render() {
        const {classes, elements, loading} = this.props;

        let noDuplicatesElements = elements.filter((element, index, self) => 
            self.findIndex(item => item.id === element.id && item.type === element.type) === index
        )

        return (
            !loading &&
            <Grid item xs={3} sm={3}>
                <Sticky>
                    <div>
                        {noDuplicatesElements.map((section, index) => (
                            <div key={index} className={classNames(classes.pbElement, classes.shadow)}>
                                <Elements
                                    isReady={true}
                                    id={section.id}
                                    text={section.type}
                                />
                            </div>
                        ))}
                    </div>
                </Sticky>
            </Grid>
        )
    }
}

export default ElementsContainer;


// WEBPACK FOOTER //
// ./src/containers/templates/builder/ElementsContainer.jsx